import styled from "styled-components";

export const SpacesContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  overflow: hidden;
  padding: 24px 0px;
  cursor: pointer;
`;

export const SpacesOverviewContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  cursor: pointer;
  border-radius: 12px;

  &:hover {
    outline-offset: 3px;
    outline: 6px solid ${({ theme }) => theme.border.brand}4d;
  }
`;

export const SpacesWrapper = styled.div`
  display: flex;
  padding: 21px 13px 13px 21px;
  flex-direction: column;
  align-items: flex-start;
  width: 89%;
  height: 225px;
  overflow: hidden;
  gap: 16px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: ${({ theme }) => theme.bg.secondary};
  box-shadow: ${({ theme }) => theme.orgchart.boxShadow};
`;

export const SpacesTitle = styled.div`
  color: ${({ theme }) => theme.text.text}
  leading-trim: both;
  text-edge: cap;
  font-family: "PP Formula";
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  line-height: 9px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;
